import React, {useContext, useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import SignInPopup from 'components/login/SignInPopup';
import {UserContext} from 'components/user/UserContext';
import {usePopup} from 'popup/PopupContext';
import {isOnLocation} from 'util/locationUtil';
import NavigationMenuSvg from 'util/svg/NavigationMenuSvg';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';

const MenuLinks = () => {
    const {user} = useContext(UserContext);
    const {openPopup} = usePopup();
    const location = useLocation();
    const {isDesktopView} = useSessionConfiguration();
    const [isTrendingPage, setIsTrendingPage] = useState(location.pathname === '/trending');
    const [isTopPage, setIsTopPage] = useState(location.pathname === '/');

    useEffect(() => {
        setIsTrendingPage(location.pathname === '/trending');
        setIsTopPage(location.pathname === '/');
    }, [location.pathname]);

    const isActive = (componentName) => {
        return isOnLocation(location.pathname, componentName, user?.userId) ? 'active' : '';
    };

    const InternalLink = ({text, path, iconName}) => {
        const grayOutClass = text !== 'THE WALL' ? 'gray-out' : '';

        return user.isLoggedIn || !grayOutClass ? (
            <Link to={path} className={`${isActive(text)} menu-link`}>
                <div className="menu-link-icon">
                    <NavigationMenuSvg name={iconName} size={30}/>
                </div>
                <div>
                    <span className="menu-link-text">
                        <span className="menu-link-main-text">{text}</span>
                    </span>
                </div>
            </Link>
        ) : (
            <div className={`${isActive(text)} menu-link ${grayOutClass}`}
                 onClick={() => openPopup(<SignInPopup/>, () => {
                 }, true)}>
                <div className="menu-link-icon">
                    <NavigationMenuSvg name={iconName} size={30}/>
                </div>
                <span className="menu-link-text">
                    {text}
                </span>
            </div>
        );
    };

    return (
        <div className={isDesktopView ? 'menu-links-container' : 'horizontal-menu'}>
            <InternalLink text="THE WALL" path={isTopPage ? "/trending" : "/"}
                          iconName={isTrendingPage ? "fire" : "wall"}/>
            <InternalLink text="PROFILE" path={'/profile/' + user.userId} iconName="images"/>
            <InternalLink text="LOOTBOX" path="/lootbox" iconName="lootbox"/>
            <InternalLink text="INVENTORY" path="/my-items" iconName="my-items"/>
            <InternalLink text="STORE" path="/item-store" iconName="store"/>
            <InternalLink text="CHAT" path="/chat" iconName="chat"/>
        </div>
    );
};

export default MenuLinks;
